<template src="./faultsPage.html"></template>

<script>
import reportMixin from '../../../../../js/reportMixin'

export default {
    name: 'faults-page',
    props: ['observations', 'headerInputs', 'sessionFields', 'headerOptionsAndValues', 'reportTitle'],
    mixins: [reportMixin],
    data() {
        return {

        }
    },
    computed: {
        session() {
            return this.$store.state.SessionsModule.Session;
        },
        sortedObservations() {
            return this.observations.sort((a,b) => a.Distance - b.Distance);
        },
    },
    methods: {
        getImageUrl(url) {
            if (window.environmentName === 'local') {
                return url;
            }

            let modifiedUrl = url.replace(/^https?:/, '').replace(/3.15.106.54/, window.baseURL);
            return modifiedUrl;
        },
        getHeaderFieldValue(header) {
            let matchingField = this.sessionFields.find((field) => field.LabelText === header);

            if (matchingField) {
                return matchingField.Value;
            } 

            return '';
        },
        calculateFaultPosition(startingPosition, endingPosition) {
            if (startingPosition && endingPosition) {
                return `Position: ${startingPosition} to ${endingPosition}`;
            }

            if (startingPosition && !endingPosition) {
                return `Position: ${startingPosition}`;
            }

            if (!startingPosition && endingPosition) {
                return `Position: ${endingPosition}`;
            }
        },
        calculateTimeStamp(videoPosition) {
            return app.calculateDisplayTimestamp(videoPosition);
        },
        checkLastObservationRow(index) {
            if (index === this.observations.length - 1) {
                return true;
            }

            return false;
        },
        checkSeverity(value) {
            if (typeof(value) === 'string') {
                return `Severity: ${value}`;
            }

            let severityNumber = Number(value);

            if (!severityNumber) {
                return 'Severity: None';
            }

            let severityTypes = {
                Severe: 5,
                Heavy: 4,
                Average: 3,
                Moderate: 2,
                Light: 1,
            }

            let severity = Object.keys(severityTypes).find(key => severityTypes[key] === severityNumber);

            return `Severity: ${severity}`
        },
    },
}

</script>
